<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-7">
          <label for="address1" class="form-label">Address line 1:</label>
          <input
            class="form-control"
            type="text"
            name="address1"
            v-model="form.address1"
          />
        </div>

        <div class="col-md-7 mt-3">
          <label for="address2" class="form-label">Address line 2:</label>
          <input
            class="form-control"
            type="text"
            name="address2"
            v-model="form.address2"
          />
        </div>

        <div class="col-md-7 mt-3">
          <label for="city" class="form-label">City:</label>
          <input
            class="form-control"
            type="text"
            name="city"
            v-model="form.city"
          />
        </div>

        <div class="col-md-7 mt-3 ">
          <label for="state" class="form-label">State:</label>
          <b-select
            class="form-select"
            name="state"
            v-model="form.state"
            aria-label="Default select example"
          >
            <option selected>AL-Alabama</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </b-select>
        </div>

        <div class="col-md-7 mt-3">
          <label for="zip" class="form-label">Zip code:</label>
          <input
            class="form-control"
            type="text"
            name="zip"
            v-model="form.zip"
          />
        </div>

        <div class="col-md-7 mt-3">
          <label for="phone" class="form-label">Phone number:</label>
          <input
            class="form-control"
            type="text"
            name="phone"
            v-model="form.phone"
          />
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "ShippingAddress",
  data() {
    return {};
  },
  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
};
</script>
<style></style>
